export { default } from './NavItem';



// WEBPACK FOOTER //
// ./src/components/atoms/NavItem/index.js